import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { OperacionLCLSCuentaLimitesAprobadosUnidadNegocio } from 'src/pages/sistema/sistemas/lcls/types/dto'
import { OperacionLCLSLimitesAprobadosUnidadNegocioFields } from 'src/pages/sistema/sistemas/lcls/types/fields'
import LimitesLCLSTabla from './LimitesLCLSTabla'

interface UnidadNegocioLCLSProps {
    data: OperacionLCLSCuentaLimitesAprobadosUnidadNegocio
}

function UnidadNegocioLCLS({ data }: UnidadNegocioLCLSProps) {
    const unidadNegocioDesc = data[OperacionLCLSLimitesAprobadosUnidadNegocioFields.DescUnidadNegocio]
    const unidadNegocioCod = data[OperacionLCLSLimitesAprobadosUnidadNegocioFields.CodUnidadNegocio]

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`panel-${unidadNegocioCod}-header`}>
                <Typography variant="h6" component="h3">
                    Unidad de Negocio: {unidadNegocioDesc ?? `Codigo ${unidadNegocioCod}`}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pb: 0 }}>
                <LimitesLCLSTabla limites={data[OperacionLCLSLimitesAprobadosUnidadNegocioFields.ListaLimites]} />
            </AccordionDetails>
        </Accordion>
    )
}

export default UnidadNegocioLCLS
